!function($) {

	"use strict";

	var InputFile = function(input, options) {
		this.input = $(input);

		this.init(options);
	};

	InputFile.DEFAULTS = {
		'buttonClass': 'btn input-file-btn',
		'label': window.translator.translate('Choose file'),
		'inputClass': 'input-file-placeholder'
	};

	InputFile.prototype = {

		constructor: InputFile,

		init: function(options) {
			this.options = $.extend({}, InputFile.DEFAULTS, options);

			this.createInputContainer()
				.createButton()
				.createPlaceholderInput()
				.registerListeners();
		},

		createInputContainer: function () {
			this.container = $('<div class="input-file-container"/>');

			this.input.wrap(this.container);

			return this;
		},

		createPlaceholderInput: function () {
			this.placeholderInput = $('<input type="text" class="' + this.options.inputClass + '" readonly />');

			this.placeholderInput.insertBefore(this.input);

			return this;
		},

		createButton: function () {
			this.button = $('<a class="' + this.options.buttonClass + '">' + this.options.label + '</a>');

			this.button.insertBefore(this.input);

			return this;
		},

		registerListeners: function() {
			var that = this;

			this.input
				.on('change.inputFile', function() {
					that.placeholderInput.val(that.input.val().split(/[\\/]/).pop());
				})
				.on('focus.inputFile', function() {
					that.button.addClass('focus');
				})
				.on('blur.inputFile', function() {
					that.button.removeClass('focus');
				})
				.on('mouseenter.inputFile', function() {
					that.button.addClass('hover');
				})
				.on('mouseleave.inputFile', function() {
					that.button.removeClass('hover focus');
				});

			return this;
		}

	};

	$.fn.inputFile = function(options) {
		this.each(function(){
			new InputFile(this, options);
		});
	};

}(window.jQuery);
